import React, { useState, useCallback } from 'react';
import { Button, Input, Textarea } from '../../Components/StyledComponents';
import { getCroppedImg } from '../Order/MenuImage/canvasUtils'
import Cropper from 'react-easy-crop'
import './CommerceCouponCreate.scss';
import axios from 'axios';
import { alertRef } from '../../App';

/* ***
../Setting/BannerImage 참고
*** */

const CommerceCouponImage = ({ addImage }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0, width: 1280, height: 1280 })
    const [imageSrc, setImageSrc] = useState(null)
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [ tempZooon, setTempZoom ] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)
    const [ isLoading, setIsLoading ] = useState(true)
    const [ isSent, setIsSent ] = React.useState(false)

    const goNext = () => {
        alertRef.current.showAlert({ title : `이미지를 등록 하시겠어요?`, subWarnTitle : '이미지는 본사에서 검수 후 노출됩니다.', isConfirm : true, confirmText : '등록', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();reqUpload()} })
    }

    const getDisabled = () => {
        if(imageSrc === null )return true
        else return false
    }

    const onZoomChange = (val) => {
        setTempZoom(zoom)
        setZoom(val)
    }

    const reqUpload = async () => {
        if(!isSent){
            setIsSent(true)
            let buffer = await getCroppedImg(imageSrc, croppedAreaPixels, rotation)

            if(buffer) getUploadURL(buffer)
            else {
                setIsSent(false)
                alertRef.current.showAlert({ title : '다시 시도해 주세요', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        }
    }

    const getUploadURL = (image) => {
        axios.get('/api/commerce/coupon/image')
        .then( (data) => {
            if(data.status === 200){
                uploadImage(image,data.data.UploadURL,data.data.FileName)
            }
        })
        .catch( () => {
            setIsSent(false)
            alertRef.current.showAlert({ title : '다시 시도해 주세요', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const uploadImage = (image,url,fileName) => {
        axios({
            method : 'PUT',
            url : url,
            headers : {
                'Content-Type': 'image/jpeg',
                'x-amz-acl': 'public-read',
            },
            data : image
        })
        .then( (data) => {
            if(data.status === 200){
                addImage(fileName)
            }
        })
        .catch( () => {
            setIsSent(false)
            alertRef.current.showAlert({ title : '다시 시도해 주세요', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        if(croppedAreaPixels.width < 1280 || croppedAreaPixels.height < 1280) setZoom(tempZooon)
        else setCroppedAreaPixels(croppedAreaPixels)
    }, [])
    
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            //let imageDataUrl = await readFile(file)
            
            const reader = new FileReader()
            reader.addEventListener('load', (e) => {
                setImageSrc(reader.result.toString() || '')
            })
            reader.readAsDataURL(e.target.files[0])
        }
    }

    const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })

    const onLoad =  async (event) => {
        const image = await createImage(imageSrc)
        if(image.naturalHeight < 1280 || image.naturalWidth < 1280 ){
            alertRef.current.showAlert({ title : '1280*1280 사이즈 이상의 이미지만 업로드 가능합니다.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            setImageSrc(null)
            return;
        }
    }
    
    return (
        <div className='commerce-coupon-create'>
            <div>
                <p className='label' style={{ width : 'fit-content'}}>쿠폰 이미지를 등록해보세요.</p>
                <p className='warn-soldout'>* 1280 * 1280 사이즈 이상 이미지 파일만 등록 가능해요.</p>                 

                <div className='file-btn' style={{ cursor : 'pointer' }}>
                    <input id="image" type="file" accept="image/*" onChange={onFileChange} onLoadedData={onLoad}></input>
                    <label htmlFor="image">
                        <div className='row' style={{ marginBottom : 0}}>
                            <img src={require('../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            이미지 선택하기
                        </div>    
                    </label>
                </div>

                {imageSrc ? (
                    <React.Fragment>
                    <div style={{ backgroundColor : 'rgba(63,63,63,0.48)', alignItems : 'center',justifyContent : 'center', display : 'flex', marginTop : 24, width : 400, height :280 }}>
                        <Cropper
                            image={imageSrc}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={1}
                            onMediaLoaded={onLoad}
                            onCropChange={setCrop}
                            cropSize={{width : 280, height : 280}}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={onZoomChange}
                            // objectFit='cover'
                            style={{containerStyle: {
                                position: 'relative',
                                width: '100%',
                                height: 280,
                                background: '#333',
                            }}}
                        />
                    </div></React.Fragment> ) : null
                }
            </div>
            
            <div className='btn-row'>
                <Button
                    variant="main"
                    fontSize={16}
                    style={{ width : 118}}
                    disabled={getDisabled()}
                    onClick={() => goNext()}
                >
                    추가하기
                </Button>
            </div>
        </div>
    )
}

export default CommerceCouponImage;